define('views/nav/breadcrumbs',[
  "globals",
  "backbone"
], function (globals, Backbone) {
  "use strict";

  return Backbone.View.extend({
    tagName: "ul",
    className: "breadcrumb visible-xs hidden-sm hidden-md hidden-lg hidden-print",
    id: "breadcrumbs",

    initialize: function () {
      _.bindAll(this, "render");
    },

    getNodeAncestry: function (node) {
      var parent = node.parent, nodes = [node];

      // Collect node ancestry into an array. If this node's parent has a
      // parent, include it in the breadcrumbs (that is, exclude the root node).
      while (parent.parent) {
        nodes.unshift(parent);
        parent = parent.parent;
      }

      return nodes;
    },

    createCrumb: function (node) {
      var $li = $("<li/>");

      // If the node has a @href attribute, make it a link. Otherwise just add
      // the text.
      if (_.has(node.data, "href")) {
        var a = $("<a/>", { href: node.data.href, text: node.title });

        // Use XHR for breadcrumb links, just as with all other local links.
        a.click(function (e) {
          e.preventDefault();
          globals.content.set("location", node.data.location);
        });

        $li.append(a);
      } else {
        $li.append(node.title);
      }

      return $li;
    },

    appendCrumbs: function (node) {
      // Get all the parent nodes of the node the user activated.
      var nodes = this.getNodeAncestry(node);

      _.each(nodes, function (node) {
        // Create a breadcrumb for each node in the ancestry, as well as the
        // current node.
        var $breadcrumb = this.createCrumb(node, _.last(nodes) !== node);

        // Append each breadcrumb into the <ul> element.
        this.$el.append($breadcrumb);
      }, this);

      return this;
    },

    render: function (e, data) {
      this.$el.empty();

      // Insert the breadcrumbs before the <main> element. The data.node
      // property contains the FancyTree object of the TOC node that the user
      // activated.
      $(".document-controls").before(this.appendCrumbs(data.node).$el);
      return this;
    }
  });
});

